import axios from "axios";
import sortBy from "lodash/sortBy";

import { ICountry } from "shared/models/location";

import config from "config/global";

class LocationService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async getCountries(locale: string): Promise<ICountry[]> {
    const response = await axios(
      `${this.url}location/countries?culture=${locale}`
    );

    return sortBy(response.data, [
      (country: ICountry): string => country.localisedCountryName,
    ]);
  }
}

export default new LocationService({
  url: config.locationsApiUrl,
});
